<script>
import DevicesImport from "./devices-import";
import { permissionMixin } from "@/mixins/permissions";
import DeviceForm from "./device-form.vue";

export default {
  name: "DevicesAction",
  components: { DevicesImport, DeviceForm },
  mixins: [permissionMixin],
  computed: {
    devices() {
      return this.$store.state.devices.devices;
    },
    dialog: {
      get() {
        return this.$store.state.devices.dialog;
      },
      set(val) {
        this.$store.dispatch("devices/toggleDialog", val);
      }
    },
    importDialog: {
      get() {
        return this.$store.state.devices.importDialog;
      },
      set(val) {
        this.$store.dispatch("devices/updateImportDialog", val);
      }
    }
  },
  methods: {
    openDialog() {
      this.$store.dispatch("devices/clearForm");
      this.$store.commit("devices/updateIndex", -1);
      this.$store.commit("devices/updateFormTitle", 1);
      this.$store.dispatch("devices/toggleDialog", true);
    },

    openImportDialog() {
      this.$store.commit("devices/updateImportDialog", true);
    },

    openRfRecordingDialog() {
      this.$store.commit("devices/updateRfRecordingOpenDialog", true);
    }
  }
};
</script>
<template>
  <div>
    <v-row class="ma-2">
      <v-btn
        color="primary"
        id="devices__open-dialog"
        class="mb-2"
        @click="openDialog()"
        :disabled="!isPermitted(PermissionEnum.DEVICES.ADD)"
        >{{ $t("modules.devices.add") }}</v-btn
      >
      <v-btn
        color="primary"
        id="devices__open-import-dialog"
        class="mb-2 ml-2"
        @click="openImportDialog()"
        :disabled="!isPermitted(PermissionEnum.DEVICES.ADD)"
        >{{ $t("modules.devices.import") }}
        <v-icon right>mdi-attachment</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="mb-2"
        id="devices_open-recordings-dialog"
        @click="openRfRecordingDialog"
        :disabled="!isPermitted(PermissionEnum.RF_RECORDINGS.VIEW)"
        >{{ $t("modules.devices.rfRecordings.seeAllRecordings") }}</v-btn
      >
    </v-row>
    <v-dialog
      v-if="
        isPermitted(PermissionEnum.DEVICES.ADD) ||
          isPermitted(PermissionEnum.DEVICES.UPDATE)
      "
      v-model="dialog"
      max-width="500px"
      persistent
      id="devices__dialog"
    >
      <device-form></device-form>
    </v-dialog>

    <devices-import></devices-import>
  </div>
</template>
